import { createSlice } from "@reduxjs/toolkit";

export interface CounterState {
  isResetLogin: boolean;
  loading: boolean;
}

const initialState: CounterState = {
  isResetLogin: false,
  loading: false,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    toggleResetLogin: (state) => {
      state.isResetLogin = !state.isResetLogin;
    },
  },
});

// Action creators are generated for each case reducer function
export const { toggleResetLogin } = loginSlice.actions;

export default loginSlice.reducer;
